// extracted by mini-css-extract-plugin
export default {"container":"src-components-PageSection-index-module_container--z7s1n"};